import { connect } from 'react-redux'
import { selectPosition, TradingAction } from '../actions'
import { AppMode, RootState } from '../types'
import { MT4Connector, TradeCommandType } from '@bdswiss/mt4-connector'
import { setAppMode, setChartMode, setTradingSymbol } from '../actions/commonActions'
import { setModal } from '../actions/dialogActions'
import { I18n } from 'react-redux-i18n'
import { closeTrade } from '../actions/TradeActions'
import AssetPositionsTable from '../components/AssetPositionsTable'
import { Dispatch } from 'redux'
const mt4 = MT4Connector.Instance

function mapDispatchToProps(dispatch: Dispatch<TradingAction>) {
  return {
    onSelectPosition: (order: number, expanded?: boolean) => {
      dispatch(selectPosition(order, expanded))
    },
    onSetChartMode: () => {
      dispatch(setChartMode('open'))
    },
    onCloseTrade: (order: number, uuid?: string) => {
      dispatch(
        setModal(I18n.t(`closingPosition`), I18n.t('closePositionMessage'), closeTrade(order, uuid))
      )
    },
    onSetAppMode: (mode: AppMode) => {
      dispatch(setAppMode(mode))
    },
    onSetSymbol: (symbol: string, type: TradeCommandType) => {
      dispatch(setTradingSymbol(symbol, type))
    },
  }
}

function mapStateToProps(rootState: RootState) {
  const state = rootState.appState
  return {
    accountLoaded: state.accountLoaded,
    // symbol: state.symbol,
    assets: mt4.assets,
    positions: Array.from(mt4.positions.values()),
    currency: state.currency,
    locale: rootState.i18n.locale,
  }
}

export const AssetPositionsTableContentContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(AssetPositionsTable)
